import React, { ChangeEvent, FC, useCallback, useEffect, useMemo, useState } from 'react';
import clsx from 'clsx';
import style from './index.module.scss';

const DEFAULT_LENGTH = 6;

interface Props {
  value?: string;
  inputRef: React.RefObject<HTMLInputElement>;
  onChange?: (value: string) => void;
  length?: number;
  autoFocus?: boolean;
  className?: string;
  type?: 'text' | 'password';
  forceFocus?: boolean;
}

export const OTPInput: FC<Props> = props => {
  const {
    value = '',
    onChange,
    length = DEFAULT_LENGTH,
    autoFocus = false,
    className,
    type = 'text',
    inputRef,
    forceFocus,
  } = props;

  const isPassword = type === 'password';

  const [inputValue, setInputValue] = useState(value);

  // 展示内容
  const inputArray = useMemo(() => {
    return new Array(length).fill('').map((_, index) => inputValue[index] || '');
  }, [inputValue, length]);

  const [isFocused, setFocus] = useState(false);

  const isInputFull = inputValue.length === length;

  useEffect(() => {
    if (autoFocus) {
      inputRef.current?.focus();
      setFocus(true);
    }
  }, [autoFocus, inputRef]);

  const handleInputCodeChange = (e: ChangeEvent<HTMLInputElement>) => {
    const eValue = e.target.value;
    const tempValue = eValue.slice(0, length);
    setInputValue(tempValue);
    onChange?.(tempValue);
  };

  const handleCodeBoxClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    inputRef.current?.focus();
    inputRef.current?.setSelectionRange(-1, -1);
    setFocus(true);
  };

  const handleBlur = useCallback(() => {
    if (forceFocus) {
      setFocus(true);
      inputRef.current?.focus();
    } else {
      setFocus(false);
    }
  }, [forceFocus, inputRef]);

  return (
    <div className={clsx(style.container, className)}>
      {/* 展示部分 */}
      <div
        className={clsx(
          'optInput-code-box',
          isInputFull && isFocused && 'optInput-code-box-active',
        )}
        onClick={handleCodeBoxClick}>
        {inputArray.map((item, index, array) => {
          const prevItemValue = index === 0 ? '-1' : array[index - 1]; // 第一项视为前一项有值
          const isItemActive = isFocused && !!prevItemValue && !item; // Input 闪烁条展示在前一项有值且当前项为空的位置
          return (
            <div
              key={index}
              className={clsx('optInput-code-item', isItemActive && 'optInput-item-active')}>
              {isPassword && item ? <div className="optInput-dot"></div> : item}
            </div>
          );
        })}
      </div>
      {/* 输入部分 */}
      <div className="optInput-box-wrap">
        <input
          type="password"
          value={inputValue}
          onChange={handleInputCodeChange}
          onFocus={() => setFocus(true)}
          onBlur={handleBlur}
          autoComplete="new-password"
          maxLength={length}
          ref={inputRef}
        />
      </div>
    </div>
  );
};
